import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a44cb2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex xs9 md7" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "group"
}
const _hoisted_4 = { class: "flex xs3 md5" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "flex xs4" }
const _hoisted_7 = { class: "flex xs4" }
const _hoisted_8 = {
  key: 0,
  class: "flex xs4"
}
const _hoisted_9 = {
  key: 1,
  class: "flex xs4"
}
const _hoisted_10 = { class: "row ml-2 pb-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex xs3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Type:")
], -1))
const _hoisted_12 = { class: "flex xs6" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "row ml-2 pb-1"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex xs3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "From:")
], -1))
const _hoisted_16 = { class: "flex xs9" }
const _hoisted_17 = {
  key: 1,
  class: "row ml-2 pb-1"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex xs3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "To:")
], -1))
const _hoisted_19 = { class: "flex xs9" }
const _hoisted_20 = {
  key: 1,
  class: "row ml-2 pb-1"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex xs3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Contract:")
], -1))
const _hoisted_22 = { class: "flex xs9" }
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 2,
  class: "row ml-2 pb-1"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex xs3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Value is:")
], -1))
const _hoisted_26 = { class: "flex xs9" }
const _hoisted_27 = {
  key: 3,
  class: "row ml-2 pb-1"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex xs3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Protocol:")
], -1))
const _hoisted_29 = { class: "flex xs9" }
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 4,
  class: "row ml-2 pb-1"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex xs3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Contract:")
], -1))
const _hoisted_33 = { class: "flex xs9" }
const _hoisted_34 = ["href"]
const _hoisted_35 = {
  key: 5,
  class: "row ml-2 pb-1"
}
const _hoisted_36 = { class: "flex xs3" }
const _hoisted_37 = { class: "flex xs9" }
const _hoisted_38 = {
  key: 6,
  class: "row ml-2 pb-1"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex xs3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Category:")
], -1))
const _hoisted_40 = { class: "flex xs9" }
const _hoisted_41 = { class: "row ml-2 pb-1" }
const _hoisted_42 = {
  key: 0,
  class: "flex xs2"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex xs4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Channels:")
], -1))
const _hoisted_44 = { class: "layout gutter--sm" }
const _hoisted_45 = { class: "row ml-2" }
const _hoisted_46 = { class: "channelChipName" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-4" }, "Delivered with Group", -1))
const _hoisted_48 = [
  _hoisted_47
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineEdit = _resolveComponent("InlineEdit")!
  const _component_GroupPicker = _resolveComponent("GroupPicker")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_button_dropdown = _resolveComponent("va-button-dropdown")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createBlock(_component_va_card, {
    class: "subscription",
    color: "#76b4e3",
    gradient: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_va_card_title, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_InlineEdit, {
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                title: "Name: "
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.showGroup)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_GroupPicker, {
                    modelValue: _ctx.group,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.group) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_va_popover, {
                  message: _ctx.pausePopoverText,
                  placement: "top",
                  "hover-over-timeout": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_inner_loading, {
                      loading: _ctx.pausing,
                      size: 18
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_button, {
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (this.togglePause()), ["prevent"])),
                          "icon-right": _ctx.pauseToggleIcon,
                          size: "small",
                          color: _ctx.paused ? 'warning' : 'success'
                        }, null, 8, ["icon-right", "color"])
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }, 8, ["message"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_va_inner_loading, {
                  loading: _ctx.destroying,
                  size: 18
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_button, {
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (this.destroy()), ["prevent"])),
                      "icon-right": "delete",
                      size: "small",
                      class: "mr-1",
                      color: "danger"
                    })
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              (!_ctx.allowEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_va_popover, {
                      message: "Coming Soon",
                      placement: "top",
                      "hover-over-timeout": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_button, {
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (this.edit()), ["prevent"])),
                          "icon-right": "edit",
                          size: "small",
                          color: "primary",
                          disabled: true
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.allowEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_va_button, {
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (this.edit()), ["prevent"])),
                      "icon-right": "edit",
                      size: "small",
                      color: "primary"
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_va_divider),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.subscriptionType), 1),
        _createVNode(_component_va_icon, {
          class: "flex xs2",
          name: _ctx.typeIcon
        }, null, 8, ["name"])
      ]),
      (_ctx.subscriptionType == 'My Wallet')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_ctx.fromAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_va_popover, { message: _ctx.fromAddress }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.fromAddressShort), 1)
                      ]),
                      _: 1
                    }, 8, ["message"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.toAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_va_popover, { message: _ctx.toAddress }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.toAddressShort), 1)
                      ]),
                      _: 1
                    }, 8, ["message"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.subscriptionType == 'Position')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("a", {
                href: _ctx.internalContractURL,
                target: "_blank"
              }, _toDisplayString(_ctx.internalContractShortAddress), 9, _hoisted_23)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.valueDescription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.valueDescription), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showProtocol)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("a", {
                href: _ctx.protocolWebsite,
                target: "_blank"
              }, _toDisplayString(_ctx.protocolName), 9, _hoisted_30)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.contractDescription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("a", {
                href: _ctx.contractURL,
                target: "_blank"
              }, _toDisplayString(_ctx.contractDescription), 9, _hoisted_34)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.contractActivity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.activityName) + ":", 1)
            ]),
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.contractActivity), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.generalTypeName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.generalTypeName), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_va_divider, {
        dashed: "",
        inset: ""
      }),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_41, [
          (_ctx.availableChannels.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createVNode(_component_va_button_dropdown, {
                  "right-icon": "",
                  icon: "add",
                  class: "mr-2 mb-2",
                  color: "secondary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableChannels, (channel) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: channel.id,
                        class: "flex pb-1"
                      }, [
                        _createVNode(_component_va_chip, {
                          style: {"font-size":"x-small"},
                          size: "small",
                          color: "secondary",
                          icon: channel.providerIcon,
                          onClick: ($event: any) => (_ctx.addChannel(channel))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(channel.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["icon", "onClick"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _hoisted_43
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels, (channel) => {
              return (_openBlock(), _createElementBlock("div", {
                key: channel.id,
                class: "flex xs6"
              }, [
                _createVNode(_component_va_chip, {
                  class: "channelChip",
                  icon: channel.providerIcon,
                  size: "small",
                  closeable: "",
                  "onUpdate:modelValue": ($event: any) => (_ctx.removeChannel(channel))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_46, _toDisplayString(channel.name), 1)
                  ]),
                  _: 2
                }, 1032, ["icon", "onUpdate:modelValue"])
              ]))
            }), 128))
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showChannels]
      ]),
      _withDirectives(_createElementVNode("div", null, _hoisted_48, 512), [
        [_vShow, !_ctx.showChannels]
      ])
    ]),
    _: 1
  }))
}